//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'swiper/dist/css/swiper.css'
import {swiper,swiperSlide} from 'vue-awesome-swiper';
import {mapActions} from 'vuex';
import vocData from '../../testdata/vocabulary';
import force from '../../common/forceLandscape';
  export default {
      name: "topic",
    components:{
      swiper,
      swiperSlide
    },
    data(){
        return{
          swiperOptions:{
            noSwiping:true,
            touchMoveStopPropagation:false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            on:{
              slideChange: ()=>{
                this.index=this.$refs.swiper.swiper.activeIndex;
              },
            },
          },
          index:0,
          imgData:[],
          buildData:[],
          zhengque:0,
          error:0
        }
    },
    methods:{
      ...mapActions(['changeTestStatus']),
      shuffle(){
        this.imgData.sort(()=>{
          return Math.random()-0.5;
        })
        return Promise.resolve('success');
      },
      checkAnswer(res){
        // res=true      //测试用
        var swiperindex=this.$refs.swiper.swiper.activeIndex;
        if(res){
          this.zhengque++;
          this.$vux.toast.text('回答正确','middle');
        }else{
          this.error++;
          this.$vux.toast.text('回答错误','middle');
        }
        if(this.error>=5){
          this.changeTestStatus({name:'vocabulary',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
            this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
          });
        }
        if(swiperindex>=7){
          this.changeTestStatus({name:'vocabulary',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
            this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
          });
        }
        this.$refs.swiper.swiper.slideTo(swiperindex+1);
      },
      play(spot){

        this.$refs.audio.src=spot;
      }
    },
    created() {
      var routename=this.$route.name;
      var tixing=this.$store.state.tixing['lv'+this.$store.state.testLevel];
      var index=tixing.indexOf(routename);
      var title=`Test ${index+1} ${this.$store.state.title['lv'+this.$store.state.testLevel][index]}`;
      document.title=title;
        this.imgData=vocData['lv'+this.$store.state.testLevel];
      this.shuffle().then(_=>{  //打乱排列
        var answerarr=[];
        for(let i=0;i<8;i++){
          var data=this.imgData.slice(i*3,i*3+3);
          var answer=data[Math.floor(Math.random()*data.length)];
          this.buildData.push({data:data,answer:answer});
          answerarr.push(answer.spot);
        }
        console.log(answerarr);
      });
    },
    mounted() {
        force();
    }
  }



// WEBPACK FOOTER //
// ./src/components/vocabulary/vocabulary.vue